<template>
    <section class="home-page-blog">
        <div class="wrapper">
            <div class="container">
                <h2 :class="{ 'blogs-tamil-fonts': selectedLanguage === 'ta', 'blogs-title': selectedLanguage !== 'ta' }">
                    {{ translations.blogs }}
                </h2>
            </div>
            <div class="row">
                <div v-if="isLoading" class="loader mt-4">
                    <div class="row">
                        <div v-for="index in 3" :key="index" class="col-lg-4 col-md-4 col-sm-12">
                            <div class="shimmer-card">
                                <p class="shimmer-line-img"></p>
                                <p class="shimmer-line"></p>
                                <p class="shimmer-line"></p>
                            </div>
                        </div>
                    </div>
                </div>

                <template v-else>
                    <div v-for="article in articles.slice(0, 3)" :key="article.article_id" class="col-lg-4 col-md-4 col-sm-12 mt-3">
                        <div class="main-blog" @click="redirectToLink(article)">
                            <div class="blog-img">
                                <template v-if="article.images.length > 0">
                                    <img v-for="(image, imageIndex) in article.images.slice(0, 1)" :key="imageIndex"
                                        :src="image" loading="lazy" alt="Article Image" />
                                </template>
                                <template v-else>
                                    <img src="../assets/images/No-Data-list.webp" loading="lazy" alt="Blog Image" />
                                </template>
                            </div>
                            <div class="blog-content">
                                <p class="blog-category">{{ article.category }}</p>
                                <h2 class="blog-title">{{ article.title }}</h2>
                                <div class="blog-btn-sec">
                                    <div :class="{ 'blog-more-tamil': selectedLanguage === 'ta', 'blog-more': selectedLanguage !== 'ta' }">
                                        <button :class="{ 'blog-more-btn-tamil': selectedLanguage === 'ta', 'blog-more-btn': selectedLanguage !== 'ta' }" @click="redirectToLink(article)">{{translations.readmore}}</button>
                                    </div>
                                    <div class="blog-date">
                                        <div class="date-icon">
                                            <img src="../assets/images/union-1.png" alt="union" loading="lazy">
                                        </div>
                                        <div class="date-blog">
                                            <span>&nbsp;&nbsp;{{ formatDate(article.created) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="blog-view-more mt-5"> 
                <a href="/blogs">
                  <button :class="{ 'blog-view-btn-tamil': selectedLanguage === 'ta', 'blog-view-btn': selectedLanguage !== 'ta' }">
                    {{translations.showmore}}
                  </button>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
import { en, ta } from "../translations.js";

export default {
    name: "BlogComponent",
    props: {
        selectedLanguage: String,
    },
    data() {
        return {
            isLoading: true, // Set to true initially to show shimmer
            articles: [],
        };
    },
    computed: {
        translations() {
            return this.selectedLanguage === "en" ? en : ta;
        },
    },
    mounted() {
        this.fetchArticles();
    },
    methods: {
        formatDate(date) {
        const formattedDate = new Date(date);

        const monthNames = [
            "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
            "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
        ];

        const day = String(formattedDate.getDate()).padStart(2, "0"); 
        const month = monthNames[formattedDate.getMonth()]; 
        const year = formattedDate.getFullYear(); 

        return `${month} ${day}, ${year}`; 
    },
        redirectToLink(article) {
            window.open(article.link, "_blank");
        },
        fetchArticles() {
            fetch("https://vaiyal-app.herokuapp.com/filterarticle", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    categoryid: "0",
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.status === "success") {
                        this.articles = data.data;
                    } else {
                        console.log("Error: " + data.msg);
                    }
                })
                .catch((error) => {
                    console.log("Error:", error);
                })
                .finally(() => {
                    this.isLoading = false; // Set loading to false after fetch completes
                });
        },
    },
};
</script>

<style>
@import url("/src/components/BlogComponent.scss");

</style>